import {FC, ReactNode, useEffect, useRef} from 'react'
import {Link} from 'react-router-dom'
import {useIsAuthenticated} from 'entities/user'
import {scrollToTop} from 'shared/lib/scroll-to'
import {text} from 'shared/mirrors/text'
import {Button} from 'shared/ui/buttons'
import {Logo} from 'shared/ui/icons'
import styles from './styles.module.scss'

type PrivacyContentProps = {
  children?: ReactNode
}

export const PrivacyContent: FC<PrivacyContentProps> = ({children}) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const isAuthenticated = useIsAuthenticated()

  useEffect(() => {
    scrollToTop(ref, 'auto')
  }, [])

  return (
    <div className={styles.page} ref={ref}>
      <div className={styles.hero}>
        <div className={styles.heroWrapper}>
          <Link to={isAuthenticated ? '/people' : '/'} className={styles.logo}>
            <div className={styles.logoIcon}>
              <Logo />
            </div>
            <h3 className={styles.logoTitle}>{text.main.siteName}</h3>
          </Link>
          {!isAuthenticated ?
            <Button
              as='link'
              to='/auth'
              className={styles.signInBtn}
              styleType='secondary'
            >
              Sign in
            </Button>
            : null}
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.wrapper}>{children}</div>
      </div>
    </div>
  )
}
